const realizar_copia_reordenamento = {
  path: "/copia-de-reordenamento",
  redirect: "/copia-de-reordenamento",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Cópia Reordenamento",
  },
  children: [
    {
      path: "/copia-de-reordenamento",
      name: "copia-de-reordenamento",
      component: () =>
        import("@/views/CopiaReordenamento/CopiaReordenamentoHome.vue"),
    },
  ],
};

export { realizar_copia_reordenamento };
